import {styled} from '@mui/material';

/** An unstyled div element that can take the sx prop */
export const SxDiv = styled('div')({});
/** An unstyled span element that can take the sx prop */
export const SxSpan = styled('span')({});
/** An unstyled img element that can take the sx prop */
export const SxImg = styled('img')({});
/** An unstyled 'a' element that can take the sx prop */
export const SxAnchor = styled('a')({});
/** An unstyled section element that can take the sx prop */
export const SxSection = styled('section')({});
